
import ImageWithDetailNew from "@/components/objects/public/attrs/image/items/ImageWithDetailNew.vue";
import TheBlockHeader from "@/components/TheBlockHeader.vue";
import { DesignExtra } from "@/utils/dto/objects.js";

export default {
  name: "ImageAttrWithDetailNew",
  components: { TheBlockHeader, ImageWithDetailNew },
  inject: {
    specialProject: {
      default: false
    }
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    objectId: {
      type: String
    },
    listInfo: {
      type: Object
    },
    useStorage: {
      type: Boolean,
      default: false
    },
    design: {
      type: String,
    },
    template: {
      type: Object,
    },
    user: {
      type: Object,
      default: () => {}
    },
    design_extra: {
      type: [Object, DesignExtra],
      default: () => {}
    },
  },
  data() {
    return {
      detail: false,
      isMobile: false,
      expandId: ''
    }
  },
  computed: {
    rowSize() {
      return this.detail ? 2 : 3
    },
    processedItems() {
      const TOTAL = this.items.length

      return this.items.map((item, index) => {
        return {
          data: item,
          direction: this.computeLayout(TOTAL, index)
        }
      })
    },
    getBlockName() {
      return this.getImageType ? 'links' + '_' + this.getImageType : 'links'
    },
    getImageType() {
      return this.items[0]?.image_type === 'image' ? 'images' : 'icons'
    },
    paletteList() {
      return this.$store.state["property_templates"]["consts"].palette;
    },
    bgPalette() {
      if (this.design_extra?.bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.bg.palette)[0];
      }

      return null;
    },
    getTextColor() {
      return this.design_extra?.text?.color ?? null;
    },
    getMask() {
      return this.design_extra?.mask?.name ?? null;
    },
    getFirstBlockBg() {
      return this.design_extra?.first_block?.bg_color ?? this.getBgColor(0) ?? null;
    },
    getFirstBlockBgGradientEnabled() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.bg?.gradient_enabled ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_enabled ?? null;
      }
    },
    getFirstBlockBgGradientDirection() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.bg?.gradient_direction ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_direction ?? null;
      }
    },
    getFirstBlockBgGradientShadowDirection() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.bg?.gradient_shadow_direction ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_shadow_direction ?? null;
      }
    },
    getFirstBlockTitleColor() {
      return this.design_extra?.first_block?.title_color ?? '#ffffff' ?? null;
    },
    getBgGradientEnabled() {
      return this.design_extra?.bg?.gradient_enabled ?? null;
    },
    getBgGradientDirection() {
      return this.design_extra?.bg?.gradient_direction ?? null;
    },
    getBgGradientShadowDirection() {
      return this.design_extra?.bg?.gradient_shadow_direction ?? null;
    },
    hasNotFirstBlockBgAndHasBgPalette() {
      if (!this.design_extra?.first_block?.bg_color && this.bgPalette) {
        return true;
      } else return false;
    }
  },
  mounted() {
    window.addEventListener('resize', this.resizeHandler, { passive: true })
  },
  created() {
    if (process.client) {
      this.resizeHandler()
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    getBgColor(index) {
      if (this.bgPalette) {
        return [this.bgPalette.main_color, ...this.bgPalette.colors][index % [this.bgPalette.main_color, ...this.bgPalette.colors].length];
      } else if (this.design_extra?.bg?.color) {
        return this.design_extra.bg.color;
      }

      return null;
    },
    checkMemberInDominoSequence(number) {
      return (number - 1) % 3 !== 0
    },
    computeLayout(total, index) {
      if (total < 2) {
        return 'to-right'
      }

      if (total % 3 === 0) {
        return this.checkMemberInDominoSequence(index) ? 'to-bottom' : 'to-top'
      }

      if (Math.max(total - 1, 0) % 3 === 0) {
        if (index === 0) return 'to-right'
        return this.checkMemberInDominoSequence(index - 1) ? 'to-bottom' : 'to-top'
      }
      if (Math.max(total - 2, 0) % 3 === 0) {
        if (index === 0 || index + 1 === total) return 'to-right'
        return this.checkMemberInDominoSequence(index - 1) ? 'to-bottom' : 'to-top'
      }

      return 'to-right'
    },
    resizeHandler() {
      this.isMobile = Boolean(window.innerWidth < 640)
    }
  }
}
